<template>
  <div class="search-page-s">
    <!-- 搜多栏 -->
    <van-search
      v-model="search" 
      :left-icon="searchIcon"
      clearable 
      @search="onSearch"/>
    <!-- 导航栏 -->
    <div class="search-nav">
      <div class="navs" 
        v-for="(item,index) in fileType" 
        :key="index" @click="change(index)" 
        :class="active == index ? 'active' : ''">{{item}}
        </div>
    </div>
    <!-- 分类搜索 -->
    <div class="search-text">分类搜索</div>
    <!-- 分类项 -->
    <div class="recommends">
      <div class="recommend" 
        v-for="(item,index) in tabType" 
        :key=index @click="changeNav(index)"
        :class="activeNav == index ? 'activeNav' : ''">{{item}}
      </div>
    </div>
    <!-- 搜索按钮 -->
    <div class="btn" @click="onSearch">
      <button>搜索</button>
    </div>
  </div>
</template>

<script>
  import { Search } from 'vant'

  export default {
    name: "home",
    comments: {
      Search 
    },
    data() {
      return {
        active:0, // 激活项
        activeNav:-1,
        search:'',// 搜索文字
        openId: '',
        searchIcon:require('./img/search.png'),
        fileTypeChecked: 1, // 选中的格式
        fileType: ["全部","文章","图文","视频"], // 文章格式
        // searchRecommend:["保险理念","保险","保险理","保险理念","保险理","保险理念手册"],
        tabType: ['贷款','保险', '健康', '教育', '汽车', '生活', '财经'], // 类别
        tabTypeChecked:'', // 选中的类别
        list: [] // 数据列表
      }
    },
    created() {
    },
    mounted() {
      this.openId = sessionStorage.getItem("openId")
    },
    methods: {
      // 切换类型
      change(index){
        this.active = index
        this.fileTypeChecked = index + 1
      },
      // 切换文章类别
      changeNav(index){
        this.activeNav = index
        // if(this.tabType[index] == '推荐') this.tabTypeChecked = '';
        this.tabTypeChecked = this.tabType[index]
      },
      // 搜索内容
      onSearch(){
        //跳转到内容页面
        this.$router.push({
          path:"/content",
          query:{
            openId:this.openId,
            search: this.search,
            fileTypeChecked: this.fileTypeChecked,
            teb_type: this.tabTypeChecked
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .active{
    color: #FF6927!important;
    font-weight: bold!important;
  }
  .activeNav{
    background: #FF6927!important;
    color: #fff!important;
  }
  .search-page-s{
    // width: 100%;
    height: calc(100vh - 32px);
    padding: 16px;
    background: #fff;
    .van-search{
      padding: 0;
      height: 32px;
      border-radius: 4px;
      overflow: hidden;
      /deep/.van-icon__image{
        color:#333333!important;
        width: 24px;
        height: 24px;
      }
      .van-search__content{
        padding-left: 12px;
      }
    }
    .search-nav{
      width: 100%;
      margin-top: 16px;
      display: flex;
      justify-content: flex-start;
      :nth-child(1){
        padding-left: 0!important;
      }
      :nth-child(4){
        border: none!important;
      }
      .navs{
        font-size: 16px;
        line-height: 16px;
        color: #999;
        padding: 0 14px;
        border-right: 1px solid #F2F2F2;
        font-family: PingFang SC;
        font-weight: medium;
      }
    }
    .search-text{
      font-size: 16px;
      font-weight: 550;
      padding: 16px 0;
    }
    .recommends{
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .recommend{
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        padding: 0px 12px;
        // background: #F6F6F6;
        border: 1px solid #f6f6f6;
        margin: 0 12px 12px 0;
        border-radius: 15px;
      }
    }
    .btn{
      position:fixed;
      bottom: 40px;
      left: 50%;
      transform:translate(-50%,0);
      
      // display: flex;
      // justify-content: center;
      button{
        width: 256px;
        height: 44px;
        font-size: 16px;
        color: #ffffff;
        background: linear-gradient(to right,#FF6521,#FFA041);
        border-radius: 22px;
        border: none;
        box-shadow: 0px 3px 6px #f1b1b1;
      }
    }
  }
</style>
